import Cookies from "js-cookie";
import { createActionType, createAsyncAction } from "./create-actions";

export const ADD_NOTIFICATION = createActionType("ADD_NOTIFICATION");
export const GET_NOTIFICATIONS = createActionType("GET_NOTIFICATIONS");
export const GET_NOTIFICATION_BY_ID = createActionType(
  "GET_NOTIFICATION_BY_ID"
);
export const EDIT_NOTIFICATION = createActionType("EDIT_NOTIFICATION");
export const REMOVE_NOTIFICATION = createActionType("REMOVE_NOTIFICATION");

export const addNotification = (data: any) =>
  createAsyncAction(
    ADD_NOTIFICATION,
    "/notification/add_notification",
    "post",
    data,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const getNotifications = () =>
  createAsyncAction(
    GET_NOTIFICATIONS,
    "/notification/get_notifications",
    "get",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const getNotificationById = (data: any) =>
  createAsyncAction(
    GET_NOTIFICATION_BY_ID,
    `/notification/get_notification_by_id/${data}`,
    "get",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const editNotification = (id: string, data: any) =>
  createAsyncAction(
    EDIT_NOTIFICATION,
    `/notification/edit_notification/${id}`,
    "put",
    data,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const removeNotification = (id: string) =>
  createAsyncAction(
    REMOVE_NOTIFICATION,
    `/notification/remove_notification/${id}`,
    "delete",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );
